export class QueryFilterCondition {
    constructor(public code: string) {

    }
}